import { render, staticRenderFns } from "./ScreenAnticipos.vue?vue&type=template&id=547aaf07"
import script from "./ScreenAnticipos.vue?vue&type=script&lang=js"
export * from "./ScreenAnticipos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports